(function() {
	var SELECTORS = [
		'img.product-item__img[data-src]',
		'.product-category-item__visual img[data-src]',
		'.gallery-item img[data-src]',
		'.product-card__slider-image img[data-src]',
		'.product-card__switcher__item img[data-src]',
		'.product-card__radio-list__label img[data-src]'
	];
	var SELECTOR = SELECTORS.join(', ');
	var SPINNER_CLASS = 'img-lazy-spinner';
	var SPINNER_FADE_MS = 350;
	var ROOT_MARGIN = '200px 0px';
	var observer = null;

	function nodeMatches(node) {
		if (!node.matches) {
			return false;
		}

		for (var i = 0; i < SELECTORS.length; i++) {
			if (node.matches(SELECTORS[i])) {
				return true;
			}
		}

		return false;
	}

	function getSpinner(img) {
		var next = img.nextElementSibling;

		if (next && next.classList.contains(SPINNER_CLASS)) {
			return next;
		}

		return null;
	}

	function ensureSpinner(img) {
		if (getSpinner(img)) {
			return;
		}

		var spinner = document.createElement('span');
		spinner.className = SPINNER_CLASS;
		spinner.setAttribute('aria-hidden', 'true');
		img.parentNode.insertBefore(spinner, img.nextSibling);
	}

	function removeSpinner(img) {
		var spinner = getSpinner(img);

		if (spinner && spinner.parentNode) {
			spinner.parentNode.removeChild(spinner);
		}
	}

	function prepareImage(img) {
		if (!img.getAttribute('data-src')) {
			return;
		}

		if (img.dataset.lazySpinnerTimeout) {
			clearTimeout(Number(img.dataset.lazySpinnerTimeout));
			delete img.dataset.lazySpinnerTimeout;
		}

		img.classList.remove('loaded');
		img.classList.add('loading');
		ensureSpinner(img);
	}

	function markLoaded(img) {
		if (img.classList.contains('loaded')) {
			return;
		}

		img.classList.remove('loading');
		img.classList.add('loaded');

		img.dataset.lazySpinnerTimeout = String(window.setTimeout(function() {
			delete img.dataset.lazySpinnerTimeout;
			removeSpinner(img);
		}, SPINNER_FADE_MS));
	}

	function bindLoadEvents(img) {
		if (img.dataset.lazyBound === 'true') {
			return;
		}

		img.dataset.lazyBound = 'true';

		img.addEventListener('load', function() {
			markLoaded(img);
		});

		img.addEventListener('error', function() {
			markLoaded(img);
		});
	}

	function loadPictureSources(img) {
		var picture = img.closest('picture');
		var sources;
		var i;

		if (!picture) {
			return;
		}

		sources = picture.querySelectorAll('source[data-srcset]');

		for (i = 0; i < sources.length; i++) {
			sources[i].srcset = sources[i].getAttribute('data-srcset');
			sources[i].removeAttribute('data-srcset');
		}
	}

	function loadImage(img) {
		var src = img.getAttribute('data-src');

		if (!src) {
			return;
		}

		bindLoadEvents(img);
		loadPictureSources(img);
		img.src = src;
		img.removeAttribute('data-src');

		if (img.complete) {
			markLoaded(img);
		}

		if (observer) {
			observer.unobserve(img);
		}
	}

	function observe(root) {
		var scope = root || document;
		var images = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
		var i;

		if (!images.length) {
			return;
		}

		for (i = 0; i < images.length; i++) {
			prepareImage(images[i]);
		}

		if (!window.IntersectionObserver) {
			for (i = 0; i < images.length; i++) {
				loadImage(images[i]);
			}
			return;
		}

		if (!observer) {
			observer = new IntersectionObserver(function(entries) {
				entries.forEach(function(entry) {
					if (!entry.isIntersecting) {
						return;
					}

					loadImage(entry.target);
				});
			}, {
				root: null,
				rootMargin: ROOT_MARGIN,
				threshold: 0
			});
		}

		for (i = 0; i < images.length; i++) {
			observer.observe(images[i]);
		}
	}

	function refreshVisibleLazyImages() {
		var images;
		var rect;
		var i;

		observe(document);

		images = document.querySelectorAll(SELECTOR);

		for (i = 0; i < images.length; i++) {
			rect = images[i].getBoundingClientRect();

			if (rect.width === 0 && rect.height === 0) {
				continue;
			}

			if (rect.bottom < -200 || rect.top > (window.innerHeight || 0) + 200) {
				continue;
			}

			loadImage(images[i]);
		}

	}

	window.technoloveObserveLazyImages = observe;
	window.technoloveRefreshVisibleLazyImages = refreshVisibleLazyImages;

	function observeAddedNodes(mutations) {
		mutations.forEach(function(mutation) {
			var j;
			var node;

			for (j = 0; j < mutation.addedNodes.length; j++) {
				node = mutation.addedNodes[j];

				if (node.nodeType !== 1) {
					continue;
				}

				if (nodeMatches(node)) {
					observe(node.parentNode || document);
				} else if (node.querySelectorAll) {
					observe(node);
				}
			}
		});
	}

	document.addEventListener('DOMContentLoaded', function() {
		observe(document);

		if (window.MutationObserver && document.body) {
			new MutationObserver(observeAddedNodes).observe(document.body, {
				childList: true,
				subtree: true
			});
		}
	});
})();
